import React, { useRef, useState , useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import clsx from "clsx";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import FilledInput from "@material-ui/core/FilledInput";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Checkbox from "@material-ui/core/Checkbox";
import { ErrorMessage } from "react-hook-form";
import { useHistory } from "react-router-dom";
import swal from "@sweetalert/with-react";
import { Grid, Container, Paper, Typography } from "@material-ui/core";
import DarkButton from "../../Global/DarkButton";
import GlobalApi from "../../Global";
import { CircularProgress } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Tooltip from '@material-ui/core/Tooltip';
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import MuiPhoneNumber from "material-ui-phone-number";
import Colors from "../../Global/colors";
import CustomToolTip from "../../Global/PasswordGuileline";
import validator from 'validator';
import { isValidPhoneNumber } from 'react-phone-number-input'
import Modal from "@material-ui/core/Modal";
import {
  hasValidLength,
  hasNumber,
  hasMixed,
  hasSpecial,
} from "../../Global/Password";
import AccountCircle from "@material-ui/icons/AccountCircle";
import "./signup.css";
import MenuItem from "@material-ui/core/MenuItem";
import name from "../../Assets/Name.png";
import Company from "../../Assets/Company.png";
import business from "../../Assets/Business_name.png";
import email from "../../Assets/email.png";
import phone from "../../Assets/Phone.png";
import password from "../../Assets/Password.png";
import globe from "../../Assets/globe.png"
import {useTranslation} from 'react-i18next';


import { useDispatch,useSelector } from "react-redux";
import {addUser} from "../../Redux/Actions/userAction"
import {addTeam} from "../../Redux/Actions/teamAction"
import {addCompany} from "../../Redux/Actions/companyAction"
import {addCompanyArr} from "../../Redux/Actions/companyArrActions"
import {addIndustryArr} from "../../Redux/Actions/industryArrActions"
import {addIndustry} from "../../Redux/Actions/industryAction"
import { updateNotification } from "../../Redux/Actions/notificationAction";

const useStyles = makeStyles((theme) => ({
  textField: {
    borderColor: Colors.globalColor4,
    backgroundColor: Colors.globalColor5,
    borderRadius: 5,
  },
  resize: {
    fontSize: 14,
  },
  verificationCode: {
    fontSize: 18,
    textAlign: "center",
  },
}));

export default function BasicTextFields(props) {
  let history = useHistory();
  const dispatch = useDispatch();
  let {t} = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let input_1 = useRef();
  let input_2 = useRef();
  let input_3 = useRef();
  let input_4 = useRef();
  let input_5 = useRef();
  let input_6 = useRef();
  let input_7 = useRef();

  const classes = useStyles();
  const [checked, setChecked] = React.useState(false);
  let [enterdCode , setEnterdCode] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [resend, setResend] = React.useState(false);
  const [industries, setIndustries] = React.useState([]);
  const [OTP, setOTP] = React.useState("");
  const [formData, setFormData] = React.useState({
    first_name: "",
    last_name: "",
    company_name: "",
    // domain_name:"",
    industry_id: "none",
    email: "",
    password: "",
    phone: "",
    term_condition: "",
    clientConsent: false,
  });
  let [errorObj, setErrorObj] = React.useState({
    email: "",
    first_name: "",
    last_name: "",
    company_name: "",
    // domain_name:"",
    industry_id: "",
    phone: "",
    password: "",
    term_condition: "",
  });
  let [codeData, setCodeData] = React.useState({
    input1: "",
    input2: "",
    input3: "",
    input4: "",
    input5: "",
    input6: "",
    input7: "",
    input8: "",
  });
  const [values, setValues] = React.useState({
    showPassword: false,
    showPasswordConfirm: false,
  });
  const [btnLoader, setBtnLoader] = React.useState(false);
  const [btnLoader2, setBtnLoader2] = React.useState(false);
  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  useEffect(()=>{
    getAllIndustries()
    if(!codeData.input1 || !codeData.input2 || !codeData.input3 || !codeData.input4 || !codeData.input5 || !codeData.input6 || !codeData.input7 || !codeData.input8){
        setEnterdCode(false);
    }
    else {
        setEnterdCode(true);
    }
  },[codeData])


  async function getAllIndustries() {
    fetch(GlobalApi + '/get_all_industries')
    .then((response) => response.json())
    .then((json) => {
    console.log('Industry Data >>>>', json)
    if (json.status === 'Success') {
    dispatch(addIndustryArr(json.data))
    console.log('under if condition')
    let industry_data = [];
    json.data.map(v => {
    industry_data.push({
    label: v.title,
    value: v.id,
    })
    })
    console.log('industry_data >>>>', industry_data);
    setIndustries(industry_data);
    }
    })
    .catch((error) => {
    console.error('Industry Error ::',error);
    });
    }



  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  console.log("codeData",codeData)
  function handleInputChange(name, value) {
    setCodeData({ ...codeData, [name]: value });
  }

  function handleForm(event) {
    let { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  }


  const getTeamData = (token, compnyID) =>{

    let params = { company_id: compnyID };
    
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_users?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        dispatch(addTeam(response));
        console.log("RESPONSE TEAM >>>>", response);
      })
      .catch((error) => console.log(error.message));
  }

  const getCompaniesArr = (token, organizationId) => {
    let params = { organization_id: organizationId };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");


    fetch(GlobalApi + "/company/companies?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((response) => {

        dispatch(addCompanyArr(response.companies));
        
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };
  

  // async function createOrganization() {
  //   console.log("formData", formData)
  //   axios
  //     .post(GlobalApi + "/initialSignUp/create_organization", {
  //       ...formData,
  //       isMobile: false,
  //     })
  //     .then(async (data) => {
  //       console.log("Data >>>>>>", data.data);
  //       if (data.data.status == "Success") {
  //         fetch(GlobalApi + '/DeviceRecord/create_device_record', {
  //           method: 'post',
  //           headers: new Headers({
  //             Authorization: 'Bearer ' + data.data.token,
  //             'Content-Type': 'application/json',
  //           }),
  //           body: JSON.stringify({
  //             company_id: data.data.companies[0].id,
  //             user_id: data.data.user.id,
  //             organization_id: data.data.data.id,
  //           }),
  //         })
  //           .then((responseJson) => responseJson.json())
  //           .then(async (device) => {
        
  //             if (data.data.status == 'Success') {
  //               let company = data.data.companies[0];
  //               let Obj = {
  //                 ...data.data.data,
  //                 company_id:company.id,
  //                 industry_id: data.data.industry_id,
  //                 super_admin:data.data.super_admin,
  //                 organization_id: data.data.data.id,
  //                 refresh_token: data.data.data.refresh_token,
  //                 token: data.data.token,
  //                 user_id: data.data.user.id,
  //                 isMobile: true,
  //                 device_id: device.data.device_id,
  //               };
                
  //                 getCompaniesArr(
  //                   data.data.token,
  //                   data.data.data.id
  //                 );
              
  //               console.log('AuthData >>>>>', Obj);
  //               await localStorage.setItem("UserData", JSON.stringify(Obj));
  //               getAllIndustries();     
  //               getTeamData(data.data.token, data.data.companies[0].id);
  //               dispatch(addUser(Obj));
  //               dispatch(addIndustry(data.data.industry_id))
  //               dispatch(addCompany(data.data.companies[0]));
  //               dispatch(updateNotification(data.data.companies[0].id));
  //               setBtnLoader2(false)
  //               swal({
  //                 title: "Congratulation!",
  //                 text: "You have successfully registered on UrAudits",
  //                 icon: "success",
  //                 button: "Ok",
  //               });
  //               setOpen(false);
  //               history.replace({
  //                 pathname: '/',
  //                 state: { onBoarding: true }
  //             });
  //               // handleOpenOnb();
  //             } else {
  //               console.log(data.data.err);
  //               setBtnLoader2(false)
  //             }
  //           });
  //       }else if(data.data.status == "pending"){

  //       } else {
  //         console.log(data.data.err);
  //         setBtnLoader2(false)
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setBtnLoader2(false)
  //     });
  // }

  // const validatePhoneNumber = (number) => {
  //   const isValidPhoneNumber = validator.isMobilePhone(number)
  //   return (isValidPhoneNumber)
  //  }

  // async function handleSubmit(e) {
  //   e.preventDefault();
  //   let { first_name, email, last_name, phone, company_name,domain_name, industry_id, password, password_confirm } = formData;
  //   console.log("formData",formData)
  //   let errors = {};
  //   //if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) === false)
  //   if (
  //     /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
  //       email
  //     ) === false
  //   ) {
  //     errors.email = "Please Enter a Valid Email.";
  //   }
  //   if (first_name.length <= 0) {
  //     errors.first_name = "This is required";
  //   }
  //   if (last_name.length <= 0) {
  //     errors.last_name = "This is required";
  //   }
  //   if(industry_id == "none"){
  //     errors.industry_id = "please select an industry";
  //   }
  //   if (company_name.length <= 0) {
  //     errors.company_name = "Company Name is required";
  //   }
  //   if (domain_name.length <= 0) {
  //     errors.domain_name = "Domain Name is required";
  //   }
  //   if (phone.length <= 5) {
  //     errors.phone = "Phone# is invalid";
  //   }
  //   if (!isValidPhoneNumber(phone)) {
  //     errors.phone = "Phone# is invalid";
  //   }
  //   if (!hasValidLength(password)) {
  //     errors.password = "Your password must have 8 or more characters";
  //   }
  //   if (!hasMixed(password)) {
  //     errors.password = "Your password must have upper & lowercase letters";
  //   }
  //   if (!hasNumber(password)) {
  //     errors.password = "Your password must have at least one number";
  //   }
  //   if (!hasSpecial(password)) {
  //     errors.password =
  //       "Your password must have at least one special character";
  //   }

  //   if (password != password_confirm) {
  //     errors.password_confirm = "password mismatch";
  //   }

  //   setErrorObj(errors);

  //   console.log(industry_id);

  //   if (Object.keys(errors).length !== 0) {
  //     // console.log("check 1")
  //     await setBtnLoader(false);
  //   }

  //   if (Object.keys(errors).length === 0) {
  //     let characters = 'txdb1s38li5h42eq0cykp7a9wgmu65jovfznr'
  //     let generateOTP = '';
  //     let length = 8 // Customize the length here.
  //     for (let i = length; i > 0; --i) generateOTP += characters[Math.round(Math.random() * (characters.length - 1))]
  //     // let generateOTP = (Math.floor(Math.random() * 10000) + 10000).toString().substring(1);
  //     console.log('generateOTP >>', generateOTP);
  //     console.log('authObj.email >>>', formData.email);
  //     setBtnLoader(true);
  //     axios
  //       .post(GlobalApi + "/initialSignUp/send_verification_code", {
  //         domain_name:formData.domain_name,
  //         email: formData.email,
  //         verification_code: generateOTP
  //       })
  //       .then(function(response) {

  //         console.log(response)
  //         if (response.data.status == "success") {
  //           console.log('if of then',response)
  //           setOTP(generateOTP);
  //           setOpen(true)
  //           setBtnLoader(false);
            
  //         } else {
  //           setBtnLoader(false);
           
  //           swal(t("Warning"), response.data.error, "warning");
  //         }
  //       })
  //       .catch((error)=> {
  //         setBtnLoader(false);
  //         console.log("catch Block")
  //         swal(t("Warning"), "Internal Server Error", "warning");
  //       });
  //   } else {
  //     setBtnLoader(false);
  //   }
  // }


    async function handleSubmit(e) {
    e.preventDefault();
    let { first_name, email, last_name, phone, company_name, industry_id, password, password_confirm } = formData;
    console.log("formData",formData)
    let errors = {};
    //if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) === false)
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      ) === false
    ) {
      errors.email = "Please Enter a Valid Email.";
    }
    if (first_name.length <= 0) {
      errors.first_name = "This is required";
    }
    if (last_name.length <= 0) {
      errors.last_name = "This is required";
    }
    if(industry_id == "none"){
      errors.industry_id = "please select an industry";
    }
    if (company_name.length <= 0) {
      errors.company_name = "Company Name is required";
    }
    // if (domain_name.length <= 0) {
    //   errors.domain_name = "Domain Name is required";
    // }
    if (phone.length <= 5) {
      errors.phone = "Phone# is invalid";
    }
    if (!isValidPhoneNumber(phone)) {
      errors.phone = "Phone# is invalid";
    }
    if (!hasValidLength(password)) {
      errors.password = "Your password must have 8 or more characters";
    }
    if (!hasMixed(password)) {
      errors.password = "Your password must have upper & lowercase letters";
    }
    if (!hasNumber(password)) {
      errors.password = "Your password must have at least one number";
    }
    if (!hasSpecial(password)) {
      errors.password =
        "Your password must have at least one special character";
    }

    if (password != password_confirm) {
      errors.password_confirm = "password mismatch";
    }

    setErrorObj(errors);

    console.log(industry_id);

    if (Object.keys(errors).length !== 0) {
      // console.log("check 1")
      await setBtnLoader(false);
    }

    if (Object.keys(errors).length === 0) {
      setBtnLoader(true);
      console.log("formData", formData)
      axios.post(GlobalApi + "/initialSignUp/create_organization", {
        ...formData,
        isMobile: false,
      }).then(function(response) {

          console.log("OOOOO",response)

          if (response.data.msg == "success") {
            setOpen(true)
            setBtnLoader(false);
            
          }else if (response.data.msg == "pending") {
            swal(t("Warning"), t("You already have an account with this email. Enter your OTP or signup with a different email"), "warning");
            setResend(true)
            setOpen(true)
            setBtnLoader(false);
            
          }else {
            setBtnLoader(false);
           
            swal(t("Warning"), response.data.error, "warning");
          }
        })
        .catch((error)=> {
          setBtnLoader(false);
      
          swal(t("Warning"), t("Internal Server Error"), "warning");
        });
    } else {
      setBtnLoader(false);
    }
  }

  const resendOtp = () =>{
    //resend Otp
    axios.post(GlobalApi + "/initialSignUp/resend_otp", {
      email:formData.email,
    }).then(function(data) {
      console.log("data",data);

      if (data.data.msg == "success") {
        swal(t("Warning"), t("OTP successfully sent"), "warning");
        
      }else {
        setBtnLoader(false);
       
        swal(t("Warning"), data.data.error, "warning");
      }
    }
    ).catch((error)=> {
      setBtnLoader(false);
  
      swal(t("Warning"), t("Internal Server Error"), "warning");
    }
    )
  }

  function verifyOtp() {
    let enterdCodeUser = `${codeData.input1}${codeData.input2}${codeData.input3}${codeData.input4}${codeData.input5}${codeData.input6}${codeData.input7}${codeData.input8}`;
    
    if (enterdCodeUser.length < 8) {
      swal(t("Warning"), t("Incomplete OTP"), "warning"); 
      return;
    }
    console.log("enterdCodeUser", enterdCodeUser);
    setBtnLoader(false);
    setBtnLoader2(true);
    axios.post(GlobalApi + "/initialSignUp/otp_verification", {
      email:formData.email,
      otp: enterdCodeUser,
    }).then(function(data) {

      console.log("data", data);

        if(data.data.msg == "success"){
          fetch(GlobalApi + '/DeviceRecord/create_device_record', {
            method: 'post',
            headers: new Headers({
              Authorization: 'Bearer ' + data.data.token,
              'Content-Type': 'application/json',
            }),
            body: JSON.stringify({
              company_id: data.data.companies[0].id,
              user_id: data.data.user.id,
              organization_id: data.data.data.id,
            }),
          })
            .then((responseJson) => responseJson.json())
            .then(async (device) => {
              console.log("success of create device", device)
              if (data.data.msg == 'success') {
                setResend(false)
                let company = data.data.companies[0];
                let Obj = {
                  ...data.data.data,
                  company_id:company.id,
                  // industry_id: data.data.industry_id,
                  super_admin:data.data.super_admin,
                  organization_id: data.data.organization_id,
                  refresh_token: data.data.data.refresh_token,
                  token: data.data.token,
                  user_id: data.data.user.id,
                  isMobile: true,
                  device_id: device.data.device_id,
                };
                
                  getCompaniesArr(
                    data.data.token,
                    data.data.data.id
                  );
              
                console.log('AuthData >>>>>', Obj);
                await localStorage.setItem("UserData", JSON.stringify(Obj));
                getAllIndustries();     
                getTeamData(data.data.token, data.data.companies[0].id);
                dispatch(addUser(Obj));
                dispatch(addIndustry(data.data.data.industry_id))
                dispatch(addCompany(data.data.companies[0]));
                dispatch(updateNotification(data.data.companies[0].id));
                setBtnLoader2(false)
                swal({
                  title: "Congratulation!",
                  text: "You have successfully registered on UrAudits",
                  icon: "success",
                  button: "Ok",
                });
                setOpen(false);
                history.replace({
                  pathname: '/template/public',
                  state: { Industry: data.data.data.industry_id }
              });
                // handleOpenOnb();
              } else {
                console.log(data.data);
                setBtnLoader2(false)
              }
            });
        }else if(data.data.msg == "error"){
          swal(t("Warning"), data.data.error, "warning");
          setBtnLoader2(false)
        }else {
          console.log(data.data.err);
          setBtnLoader2(false)
        }

      })
      .catch((error)=> {
        setBtnLoader2(false);
    
        swal(t("Warning"), error.message, "warning");
      });
  }


  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleClickShowPasswordConfirm = () => {
    setValues({ ...values, showPasswordConfirm: !values.showPasswordConfirm });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };



  return <form onSubmit={handleSubmit}>
      <Grid container direction="row" justify="flex-start" spacing={1}>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField error={errorObj.first_name} id="outlined-basic" className={classes.textField} InputProps={{ startAdornment: <InputAdornment position="start">
                  <img src={name} width={12} />
                </InputAdornment>, classes: { input: classes.resize } }} fullWidth variant="outlined" placeholder={t("First Name")} size="small" name="first_name" helperText={errorObj.first_name} onChange={handleForm} value={formData.first_name} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField id="outlined-basic" fullWidth size="small" className={classes.textField} InputProps={{ startAdornment: <InputAdornment position="start">
                  <img src={name} width={12} />
                </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Last Name")} name="last_name" variant="outlined" error={errorObj.last_name} onChange={handleForm} helperText={errorObj.last_name} value={formData.last_name} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <MuiPhoneNumber error={errorObj.phone} helperText={errorObj.phone} disableAreaCodes={true} className={classes.textField} InputProps={{ startAdornment: <InputAdornment position="start">
                  <img src={phone} width={10} />
                </InputAdornment>, classes: { input: classes.resize } }} placeholder={t("Mobile Number")} size="small" variant="outlined" name="phone" fullWidth value={formData.phone} onChange={(value, data) => {
              // console.log(data);
              setFormData({ ...formData, phone: value });
            }} />
        </Grid>

        {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <Tooltip disableHoverListener title={<><h4 style={{display:'inline'}}>Hint :</h4><p style={{display:'inline', fontWeight:'bold'}}> @example.com / @example.co.uk</p></>}>
            <TextField error={errorObj.domain_name} id="outlined-basic" autoComplete={'off'} className={classes.textField} InputProps={{ startAdornment: <InputAdornment position="start">
                    <img src={globe} width={12} />
                  </InputAdornment>, classes: { input: classes.resize } }} fullWidth variant="outlined" placeholder="Domain Name" size="small" name="domain_name" helperText={errorObj.domain_name} onChange={handleForm} value={formData.domain_name} />
          </Tooltip>{" "}
        </Grid> */}

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField error={errorObj.company_name} id="outlined-basic" className={classes.textField} InputProps={{ startAdornment: <InputAdornment position="start">
                  <img src={Company} width={12} />
                </InputAdornment>, classes: { input: classes.resize } }} fullWidth variant="outlined" placeholder={t("Company Name")} size="small" name="company_name" helperText={errorObj.company_name} onChange={handleForm} value={formData.company_name} />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField fullWidth error={errorObj.email} helperText={errorObj.email} id="outlined-basic" size="small" placeholder={t("Business Email")} className={classes.textField} InputProps={{ startAdornment: <InputAdornment position="start">
                  <img src={email} width={14} />
                </InputAdornment>, classes: { input: classes.resize } }} onChange={handleForm} variant="outlined" name="email" value={formData.email} />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <TextField id="outlined-select-currency" select displayEmpty fullWidth className={classes.textField} size="small" placeholder="Placeholder" name="industry_id" InputProps={{ startAdornment: <InputAdornment position="start">
                  <img src={business} width={14} />
                </InputAdornment>, classes: { input: classes.resize } }} onChange={handleForm} helperText={errorObj.industry_id} value={formData.industry_id} variant="outlined">
            <MenuItem value={"none"}>
              <span className="specialSelect">{t("Business Industry")}</span>
            </MenuItem>
            {industries.length > 0 && industries.map((item, index) => {
                return <MenuItem value={item.value} style={{ fontSize: 14, color: Colors.globalColor8 }}>
                    {item.label}
                  </MenuItem>;
              })}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <FormControl className={classes.textField} variant="outlined" fullWidth size="small" InputProps={{ classes: { input: classes.resize } }}>
            <CustomToolTip>
              <OutlinedInput error={errorObj.password} size="small" helperText={errorObj.password} name="password" placeholder={t("Password")} className={(classes.textField, classes.resize)} id="outlined-adornment-password" type={values.showPassword ? "text" : "password"} value={values.password} onChange={handleForm} startAdornment={<InputAdornment position="start">
                    <img src={password} width={10} />
                  </InputAdornment>} endAdornment={<InputAdornment position="end">
                    <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end" className="eyeIcon">
                      {values.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>} />
            </CustomToolTip>
            <span style={{ color: "red", fontSize: "12px" }}>
              {errorObj.password}
            </span>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined" fullWidth size="small">
            <OutlinedInput error={errorObj.password_confirm} helperText={errorObj.password_confirm} fullWidth name={t("password_confirm")} placeholder={t("Confirm Password")} className={(classes.textField, classes.resize)} size="small" id="outlined-adornment-password" type={values.showPasswordConfirm ? "text" : "password"} value={values.password_confirm} onChange={handleForm} startAdornment={<InputAdornment position="start">
                  <img src={password} width={10} />
                </InputAdornment>} endAdornment={<InputAdornment position="end">
                  <IconButton aria-label="toggle password visibility" onClick={handleClickShowPasswordConfirm} onMouseDown={handleMouseDownPassword} edge="end" className="eyeIcon">
                    {values.password_confirm ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>} />
            <span style={{ color: "red", fontSize: "12px", marginLeft: 15 }}>
              {errorObj.password_confirm}
            </span>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{textAlign:language == "ar" ?'right' : 'left'}}>
          <FormControlLabel className={"consentForm"} control={<Checkbox checked={formData.clientConsent} onChange={() => {
                  setFormData({
                    ...formData,
                    clientConsent: !formData.clientConsent,
                  });
                }} name="checkedB" color={Colors.globalColor8} size="small" />} label={t("By Registering you Agree to UrAudits Terms and Privacy Policy")} style={{ fontSize: 10 }} />
        </Grid>

        <Modal open={open}>
          <div className="modal-size">
            <Typography variant="h6" className="modal-title">
              {t("Verification Code")}
            </Typography>
            <p className="modal-subTitle">
              {t("Enter the verification code sent to your email to access your account")}
            </p>
            <Grid container spacing={1} style={{ flexDirection: "row" }}>
              <Grid item>
                <input autoFocus type="text" pattern="\d*" maxlength="1" className="codeInput" onChange={(text) => {
                    input_1.focus();
                    handleInputChange("input1", text.target.value.toLowerCase());
                  }} />
              </Grid>
              <Grid item>
                <input type="text" maxlength="1" className="codeInput" ref={(val) => (input_1 = val)} onChange={(text) => {
                    input_2.focus();
                    handleInputChange("input2", text.target.value.toLowerCase());
                  }} />
              </Grid>
              <Grid item>
                <input type="text" pattern="\d*" maxlength="1" className="codeInput" ref={(val) => (input_2 = val)} onChange={(text) => {
                    input_3.focus();
                    handleInputChange("input3", text.target.value.toLowerCase());
                  }} />
              </Grid>
              <Grid item>
                <input type="text" pattern="\d*" maxlength="1" className="codeInput" ref={(val) => (input_3 = val)} onChange={(text) => {
                    input_4.focus();
                    handleInputChange("input4", text.target.value.toLowerCase());
                  }} />
              </Grid>

              <Grid item>
                <input type="text" pattern="\d*" maxlength="1" ref={(val) => (input_4 = val)} className="codeInput" onChange={(text) => {
                    input_5.focus();
                    handleInputChange("input5", text.target.value.toLowerCase());
                  }} />
              </Grid>
              <Grid item>
                <input type="text" maxlength="1" className="codeInput" ref={(val) => (input_5 = val)} onChange={(text) => {
                    input_6.focus();
                    handleInputChange("input6", text.target.value.toLowerCase());
                  }} />
              </Grid>
              <Grid item>
                <input type="text" pattern="\d*" maxlength="1" className="codeInput" ref={(val) => (input_6 = val)} onChange={(text) => {
                    input_7.focus();
                    handleInputChange("input7", text.target.value.toLowerCase());
                  }} />
              </Grid>
              <Grid item>
                <input type="text" pattern="\d*" maxlength="1" className="codeInput" ref={(val) => (input_7 = val)} onChange={(text) => {
                    handleInputChange("input8", text.target.value.toLowerCase());
                  }} />
              </Grid>
            </Grid>
            <br />
            <DarkButton size="medium" style={{ backgroundColor: Colors.globalColor8, padding: "5px 10px" }} onClick={() => verifyOtp()}>
              {btnLoader2 == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />} OK
            </DarkButton>
&emsp;
            {resend && <DarkButton size="medium" style={{ backgroundColor: Colors.globalColor8, padding: "5px 10px" }} onClick={() => resendOtp()}>
             {t("Resend OTP")}
            </DarkButton>}
          </div>
        </Modal>

        <Grid item xs={12} sm={12} md={12}>
          {window.innerWidth > 500 && <DarkButton size="medium" type="submit" disabled={!formData.clientConsent || btnLoader == true} style={!formData.clientConsent ? { backgroundColor: "gray" } : { backgroundColor: Colors.globalColor8 }}>
              {btnLoader == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />}
              {t("Create My Account")}
            </DarkButton>}

          {window.innerWidth <= 500 && <DarkButton type="submit" disabled={!formData.clientConsent || btnLoader == true} style={!formData.clientConsent ? { backgroundColor: "gray", width: "100%" } : { width: "100%", backgroundColor: Colors.globalColor8 }}>
              {btnLoader == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />}
              {t("Create My Account")}
            </DarkButton>}
        </Grid>
      </Grid>
    </form>;
}
